import React from 'react';
import { useSelector } from 'react-redux';
import { useLabels } from 'wsm-common-data';
import { selectDeptsWithStaff } from '../features/departments/departmentsSlice';
import DeptLink from './DeptLink';
import { getSlug } from '../utils/helperFunctions';

const DeptLinks = () => {
	const labels = useLabels();
	const departments = useSelector((state) => selectDeptsWithStaff(state));

	return (
		<div>
			{departments.length > 0 &&
				departments.map(({ label }, i) => {
					const labelValue = labels.get(label);
					return (
						<DeptLink
							key={labelValue}
							label={labelValue}
							linkClasses={i > 0 ? 'ml-4' : ''}
							hrefAttr={`#${getSlug(labelValue)}`}
						>
							{labelValue}
						</DeptLink>
					);
				})}
		</div>
	);
};

export default DeptLinks;
